import { createPortal } from 'react-dom';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

export default function ReportBreadCrumbs({ baseReportName, reportsPath, savedReport }) {
  const anchorProps = {};
  if (savedReport?.name) anchorProps.href = reportsPath;

  return (
    createPortal(
      <React.Fragment>
        <a className="ds-text-secondary" {...anchorProps} >
          {savedReport?.name ? 'My Reports' : baseReportName}
        </a>
        {savedReport?.name ? (
          <React.Fragment>
            <FontAwesomeIcon icon={faChevronRight} size="sm"/>
            {savedReport.name}
          </React.Fragment>
        ) : null}
      </React.Fragment>,
      document.getElementById('saved-report-portal')
    )
  );
}

ReportBreadCrumbs.propTypes = {
  baseReportName: PropTypes.string.isRequired,
  reportsPath: PropTypes.string.isRequired,
  savedReport: PropTypes.object,
};
